import { useState } from 'react';
import { Minus, Plus } from 'lucide-react';

// ── Quantity controls (shared by the Casegoods Inventory and Materials pages) ──

export interface QtyControlsProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onDirectEdit: (n: number) => void;
}

export function QtyControls({ quantity, onIncrement, onDecrement, onDirectEdit }: QtyControlsProps) {
  const [raw, setRaw] = useState(String(quantity));
  const [editing, setEditing] = useState(false);

  if (!editing && raw !== String(quantity)) {
    setRaw(String(quantity));
  }

  return (
    <div className="flex items-center gap-1 shrink-0">
      <button
        type="button"
        onClick={onDecrement}
        className="w-8 h-8 flex items-center justify-center rounded-lg border border-stone
                   text-slate hover:text-midnight hover:border-plum/40 active:bg-mist
                   transition-colors duration-100"
        aria-label="Decrease quantity"
      >
        <Minus size={14} />
      </button>

      <input
        type="number"
        min="0"
        step="1"
        value={raw}
        onFocus={() => setEditing(true)}
        onChange={e => setRaw(e.target.value)}
        onBlur={() => {
          const n = parseInt(raw, 10);
          if (isNaN(n) || n < 0) setRaw(String(quantity));
          else onDirectEdit(n);
          setEditing(false);
        }}
        onKeyDown={e => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }}
        className="w-12 h-8 text-center rounded-lg border border-stone bg-white
                   text-small font-semibold text-midnight
                   focus:outline-none focus:border-plum focus:ring-2 focus:ring-plum/20
                   transition-colors duration-150"
        aria-label="Quantity"
      />

      <button
        type="button"
        onClick={onIncrement}
        className="w-8 h-8 flex items-center justify-center rounded-lg border border-stone
                   text-slate hover:text-midnight hover:border-plum/40 active:bg-mist
                   transition-colors duration-100"
        aria-label="Increase quantity"
      >
        <Plus size={14} />
      </button>
    </div>
  );
}

